module.exports = __webpack_public_path__ + "media/La.14069238.wav";